import { DeviceInfoResponse } from './device-info.response';
import { GDSTroubleshooterMessage, LocationInfoStatus, LocationInfoStatusOptions } from './location-info';
import { PermissionInfo } from './permissions';

export type Optional<Type> = Type | undefined | null;

export type OnInitialized<K> = Optional<(initializationStatus?: Optional<K>) => void>;
export type OnUninitialized = Optional<() => void>;

export const enum CoordinatorStates {
    NOTINITIALIZED = 'NOTINITIALIZED',
    INITIALIZING = 'INITIALIZING',
    INITIALIZED = 'INITIALIZED',
    ERROR = 'ERROR',
    LOCATIONAVAILABLE = 'LOCATIONAVAILABLE',
    PROBING = 'PROBING',
}

export type PLCIdentifier = 'geocomply' | 'oobeeAndroid' | 'oobeeiOS' | 'gchtml5';

export interface ConfigurationData {
    readonly enableNDBS: boolean;
}

export interface IPLCProbeResult {
    readonly status: boolean;
    readonly additionalInfo?: Object;
}

export type OnCoordinatorProbed = (probeResult: ICoordinatorProbeResult) => void;
export interface ICoordinatorProbeResult extends IPLCProbeResult {
    readonly coordinatorState: CoordinatorStates;
}

export type OnProbed = (probeResult: ICoordinatorProbeResult) => void;

export interface IOnError {
    onError: OnError;
}
export interface IErrorData {
    errorCode: number;
    errorMessage: string;
    errorType?: ErrorTypes;
    additionalInfo?: any;
}
export enum ErrorTypes {
    APP_ERROR = 'APPLICATION_ERROR',
    COMM_ERROR = 'COMMUNICATION_ERROR',
    NETWORK_ERROR = 'NETWORK_ERROR',
    DATA_ERROR = 'DATA_ERROR',
    CONFIG_ERROR = 'CONFIGURATION_ERROR',
    FATAL = 'FATAL',
}
export type OnError = Optional<(errorData: IErrorData) => void>;

export interface IIntegrationApp {
    readonly appDownloadUrl: string;
    readonly configuration: Optional<ConfigurationData>;
    onInitialized: OnInitialized<CoordinatorStates>;
    onError: OnError;
    onProbed: OnProbed;
    onUninitialized: OnUninitialized;
    initialize(input?: IInitializationInput): void;
    probe(input?: IInitializationInput): void;
    uninitialize(): void;
    triggerFetchLocation(input?: IInitializationInput): void;
    locationInfoStatus(infoData: LocationInfoStatusOptions): void;
    handleLocationInfoStatus(
        locationInfoStatus?: LocationInfoStatus,
        notOkCallback?: (permissionsInfo: PermissionInfo) => void,
        okCallback?: () => void,
    ): void;
}

export interface IInitializationInput {
    readonly session?: string;
    readonly channelId?: string;
    readonly plcIdentifier?: PLCIdentifier | string;
    readonly showPLCPopup?: boolean;
    readonly productId?: string;
}

export enum RetryType {
    NonRetry = 0,
    Retry = 1,
}

export interface GDSResponse extends DeviceInfoResponse {
    locationStatus: string;
    isLocationAvailable: boolean;
    errorCode: number;
    errorMsg: string;
    troubleShooterMessages?: { tsMsgs?: GDSTroubleshooterMessage[] };
}
